export const SHOW_COUNTDOWN_TIP_LICENSE_DAYS_TO_EXPIRATION = 15

export const LicenseManagerStatus = {
    ACTIVE: 'ACTIVE',
    PENDING_ACCEPTANCE: 'PENDING_ACCEPTANCE',
    DECLINE_ACCEPTANCE: 'DECLINE_ACCEPTANCE',
    REVOKED: 'REVOKED',
    PREDEFINED: 'PREDEFINED',
    DISABLED: 'DISABLED'
}

export const licensesType = {
    TRIAL: 'trial',
    COMMERCIAL: 'commercial',
    FREE: 'free',
}



// WEBPACK FOOTER //
// ./web/js/activeLicenseInfo/constants.js